import React from 'react';
import { IconProps } from '.';

const SvgLinkExternal = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='m2.251 2.25 7.762.009-.002 1.5-6.26-.008v16.498l16.499.001-.002-6.239h1.5l.002 7.74-19.5-.002.001-19.5Z'
      />
      <path fill={color} d='M21.75 2.25V10h-1.5V4.811l-7.72 7.72-1.06-1.06 7.72-7.721H14v-1.5h7.75Z' />
    </svg>
  );
};

export default SvgLinkExternal;
